import { FormControlLabel as MuiFormControlLabel } from '@mui/material'

export const FormControlLabel = ({ label, control, ...otherProps }: any) => {
  return (
    <MuiFormControlLabel
      aria-label={label}
      onClick={(event) => event.stopPropagation()}
      onFocus={(event) => event.stopPropagation()}
      control={control}
      label={label}
      {...otherProps}
    />
  )
}
